import { create } from "zustand";

const useImagesStore = create<ImagesStore>((set) => ({
  isUploading: false,

  // A generic setter function that works for any piece of state
  setState: (key, value) => set(() => ({ [key]: value })),
}));

export default useImagesStore;

interface ImagesStore {
  isUploading: boolean;
  setState: <K extends keyof Omit<ImagesStore, "setState">>(key: K, value: ImagesStore[K]) => void;
}
